import React from 'react';
import ReactDOM from 'react-dom';
import { StoreContext } from 'storeon/react/index';

import ServiceRequestForm from './components/ServiceForms/ServiceRequestForm';
import ServiceRequestDealerForm from './components/ServiceForms/ServiceRequestDealerForm';
import ServiceRequestMiwindowsForm from './components/ServiceForms/ServiceRequestMiwindowsForm';
import ServiceRequestDealerMiwindowsForm from './components/ServiceForms/ServiceRequestDealerMiwindowsForm';
import ImpactRecallForm from './components/ServiceForms/ImpactRecallForm';
import ServiceRequestHomeCenterForm from './components/ServiceForms/ServiceRequestHomeCenterForm';
import ServiceRequestFormStore from './store/ServiceRequestFormStore';
import ServiceRequestDealerFormStore from './store/ServiceRequestDealerFormStore';
import ServiceRequestMiwindowsFormStore from './store/ServiceRequestMiwindowsFormStore';
import ServiceRequestDealerMiwindowsFormStore from './store/ServiceRequestDealerMiwindowsFormStore';
import ImpactRecallFormStore from './store/ImpactRecallFormStore';
import ServiceRequestHomeCenterFormStore from './store/ServiceRequestHomeCenterFormStore';

import './styles/main.scss';

(() => {
    let formWrappers = document.querySelectorAll( '.service-request-form-wrapper' );
    formWrappers.forEach( ( formWrapper ) => {
        let idForm = formWrapper.id;

        const arrForm = [
            {
                renderingLocation: 'service_request',
                form: <ServiceRequestForm id={'service_request'}/>,
                store: ServiceRequestFormStore,
            }, {
                renderingLocation: 'service_request_dealer',
                form: <ServiceRequestDealerForm id={'service_request_dealer'}/>,
                store: ServiceRequestDealerFormStore,
            }, {
                renderingLocation: 'service_request_miwindows',
                form: <ServiceRequestMiwindowsForm id={'service_request_miwindows'}/>,
                store: ServiceRequestMiwindowsFormStore,
            }, {
                renderingLocation: 'service_request_dealer_miwindows',
                form: <ServiceRequestDealerMiwindowsForm id={'service_request_dealer_miwindows'}/>,
                store: ServiceRequestDealerMiwindowsFormStore,
            }, {
                renderingLocation: 'service_request_home_center',
                form: <ServiceRequestHomeCenterForm id={'service_request_home_center'}/>,
                store: ServiceRequestHomeCenterFormStore,
            }, {
                renderingLocation: 'warranty_impact_recall_1620',
                form: <ImpactRecallForm id={'warranty_impact_recall_1620'}/>,
                store: ImpactRecallFormStore,
            }
        ];
        let idFormIndex = arrForm.map( object => object.renderingLocation ).indexOf( idForm );
        idFormIndex = (idFormIndex === -1) ? 0 : idFormIndex;
        const { form, store } = arrForm[idFormIndex];
        ReactDOM.render(
            <StoreContext.Provider value={store}>
                {form}
            </StoreContext.Provider>,
            formWrapper
        );
    } );
})();



